import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import { aiChatKeys } from './aiChatKeys';

export const createFetchChatHistoryQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ kind, id }], signal }: QueryFunctionContext<ReturnType<typeof aiChatKeys.detail>>) => {
    if (kind === 'repository') {
      return call(() => cancelOnSignal(AdminService.getRepositoryChatHistory({ repositoryId: id }), signal));
    }
    return call(() => cancelOnSignal(AdminService.getTranscriptChatHistory({ transcriptId: id }), signal));
  };
